import React from "react";
import { Checkbox, TextField } from "@mui/material";
import { Field, Form } from "react-final-form";
import styled from "styled-components";
import { useCartContext } from "../context/cart_context";
import { send } from "emailjs-com";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";

const textFieldSx = {
  width: "100%",
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    backgroundColor: "var(--clr-paper)",
    fontFamily: "var(--ff-body)",
    fontSize: "1rem",
    "& fieldset": {
      borderColor: "var(--clr-divider)",
    },
    "&:hover fieldset": {
      borderColor: "var(--clr-accent-light)",
    },
    "&.Mui-focused fieldset": {
      borderColor: "var(--clr-accent)",
      borderWidth: "2px",
    },
  },
  "& .MuiInputLabel-root": {
    fontFamily: "var(--ff-body)",
    color: "var(--clr-charcoal-3)",
    "&.Mui-focused": {
      color: "var(--clr-accent-dark)",
    },
  },
};

const SendingForm = ({ cart, onSendingChange }) => {
  const { total_amount, total_bail, total_amount_weekend, clearCart } =
    useCartContext();
  const items = cart.map((item) => item.name + " počet kusů: " + item.amount);

  const onSubmit = (values) => {
    values.cart = items;
    values.total_amount = total_amount;
    values.total_amount_weekend = total_amount_weekend;
    values.total_bail = total_bail;

    onSendingChange(true);
    return send("service_cn3osvr", "template_vs8kcv6", values, "rGu_ZsJK6iBb10LOe")
      .then(() => {
        toast.success("Objednávka úspěšně odeslána!", {
          position: "top-center",
          autoClose: 5000,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
        });
        clearCart();
      })
      .catch(() => {
        toast.error("Jejda, něco se pokazilo. Zkuste to prosím znovu.", {
          position: "top-center",
          autoClose: 5000,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
        });
      })
      .finally(() => {
        onSendingChange(false);
      });
  };

  const required = (value) => (value ? undefined : "Vyžadováno");

  return (
    <Wrapper>
      <div className="form-card">
        <span className="script">Nezávazná poptávka</span>
        <h3>Vaše údaje</h3>
        <p className="hint">Vyplňte prosím kontaktní údaje. Cenu potvrdíme e-mailem.</p>

        <Form
          keepDirtyOnReinitialize
          onSubmit={onSubmit}
          render={({ handleSubmit }) => (
            <form id="my-form" onSubmit={handleSubmit}>
              <div className="formField">
                <div className="field">
                  <Field name="name" validate={required}>
                    {({ input, meta }) => (
                      <>
                        <TextField
                          label="Jméno *"
                          variant="outlined"
                          type="text"
                          sx={textFieldSx}
                          {...input}
                        />
                        {meta.error && meta.touched && (
                          <span className="error">{meta.error}</span>
                        )}
                      </>
                    )}
                  </Field>
                </div>
                <div className="field">
                  <Field name="lastName" validate={required}>
                    {({ input, meta }) => (
                      <>
                        <TextField
                          label="Příjmení *"
                          variant="outlined"
                          type="text"
                          sx={textFieldSx}
                          {...input}
                        />
                        {meta.error && meta.touched && (
                          <span className="error">{meta.error}</span>
                        )}
                      </>
                    )}
                  </Field>
                </div>
                <div className="field">
                  <Field name="ico">
                    {({ input, meta }) => (
                      <>
                        <TextField
                          label="IČO"
                          variant="outlined"
                          type="number"
                          sx={textFieldSx}
                          {...input}
                        />
                        {meta.error && meta.touched && (
                          <span className="error">{meta.error}</span>
                        )}
                      </>
                    )}
                  </Field>
                </div>
                <div className="field">
                  <Field name="telephone" validate={required}>
                    {({ input, meta }) => (
                      <>
                        <TextField
                          label="Telefon *"
                          variant="outlined"
                          type="number"
                          sx={textFieldSx}
                          {...input}
                        />
                        {meta.error && meta.touched && (
                          <span className="error">{meta.error}</span>
                        )}
                      </>
                    )}
                  </Field>
                </div>
              </div>

              <div className="singleFields">
                <div className="field">
                  <Field name="email" validate={required}>
                    {({ input, meta }) => (
                      <>
                        <TextField
                          label="Email *"
                          variant="outlined"
                          sx={textFieldSx}
                          type="email"
                          {...input}
                        />
                        {meta.error && meta.touched && (
                          <span className="error">{meta.error}</span>
                        )}
                      </>
                    )}
                  </Field>
                </div>
                <div className="field">
                  <Field name="message">
                    {({ input, meta }) => (
                      <>
                        <TextField
                          label="Detaily k objednávce"
                          multiline
                          rows={4}
                          sx={textFieldSx}
                          {...input}
                        />
                        {meta.error && meta.touched && (
                          <span className="error">{meta.error}</span>
                        )}
                      </>
                    )}
                  </Field>
                </div>
                <div className="gdpr-row">
                  <Field
                    name="GDPR"
                    validate={required}
                    defaultValue="true"
                    type="checkbox"
                  >
                    {({ input, meta }) => (
                      <>
                        <Checkbox
                          {...input}
                          type="checkbox"
                          sx={{
                            color: "var(--clr-accent-dark)",
                            "&.Mui-checked": { color: "var(--clr-accent)" },
                            padding: "0.5rem",
                          }}
                        />
                        <Link to="/info" className="gdpr-link">
                          Souhlasím se zpracováním osobních údajů (GDPR) a smluvními podmínkami firmy BBS s.r.o.
                        </Link>
                        {meta.error && meta.touched && (
                          <span className="error gdpr-error">{meta.error}</span>
                        )}
                      </>
                    )}
                  </Field>
                </div>
              </div>
            </form>
          )}
        />
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  margin: 2.5rem 0;

  .form-card {
    background: var(--clr-paper);
    border: 1px solid var(--clr-divider);
    border-radius: var(--radius-lg);
    padding: 2rem 1.5rem;
    box-shadow: var(--shadow-sm);
  }

  .script {
    font-family: var(--ff-script);
    color: var(--clr-accent);
    font-size: 1.4rem;
    display: block;
    margin-bottom: 0.25rem;
  }
  h3 {
    margin-bottom: 0.5rem;
    color: var(--clr-charcoal-1);
    text-transform: none;
  }
  .hint {
    color: var(--clr-charcoal-3);
    margin-bottom: 1.5rem;
    font-size: 0.95rem;
  }

  .formField {
    display: grid;
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  .singleFields {
    margin-top: 1rem;
    display: grid;
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  .field {
    display: flex;
    flex-direction: column;
  }
  .error {
    color: var(--clr-red-dark);
    font-size: 0.8rem;
    margin-top: 0.25rem;
  }

  .gdpr-row {
    display: grid;
    grid-template-columns: auto 1fr;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 0;
  }
  .gdpr-link {
    color: var(--clr-charcoal-2);
    text-decoration: underline;
    text-underline-offset: 3px;
    font-size: 0.9rem;
  }
  .gdpr-link:hover {
    color: var(--clr-accent-dark);
  }
  .gdpr-error {
    grid-column: 1 / -1;
  }

  @media (min-width: 600px) {
    .form-card {
      padding: 2.5rem 2rem;
    }
  }
  @media (min-width: 992px) {
    .formField {
      grid-template-columns: repeat(2, 1fr);
    }
  }
`;

export default SendingForm;
